import { create } from 'zustand';

const useSongsStore = create((set) => ({
  songs: [],
  setSongs: (songs) => set(() => ({ songs })),
  removeSong: (song) => set((state) => ({ songs: state.songs.filter((item) => item.id !== song.id) })),
  addSong: (song) => set((state) => ({ songs: [...state.songs, song] })),
  addSongList: (songsList) => set((state) => ({ songs: [...state.songs, ...songsList] })),
  currSongToPlay: {
    isPlaying: false,
    song: null,
  },
  setCurrSongToPlay: (song) => set(() => ({ currSongToPlay: song })),
}));

export default useSongsStore;

